import request from '@/utils/request';
export function signup(data) {
    return request({
        url: '/user/signup',
        method: 'post',
        data
    });
}
export function signin(data) {
    return request({
        url: '/user/signin',
        method: 'post',
        data
    });
}
export function getInfo() {
    return request({
        url: '/user/info',
        method: 'get'
    });
}
export function getMyhelp(params) {
    return request({
        url: '/fund/myhelp',
        method: 'get',
        params
    });
}
export function getpublishAsset(id) {
    return request({
        url: `/fund/publish-asset/${id}`,
        method: 'get'
    });
}
export function postpatientDemand(data) {
    return request({
        url: `/fund/patient/demand`,
        method: 'post',
        data
    });
}
export function postPassport() {
    return request({
        url: `/passport/logout`,
        method: 'post',
    });
}
export function getPassportInfo() {
    return request({
        url: `/passport/logout/info`,
        method: 'get',
    });
}
